import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import {
  Validators,
  ValidatorFn,
  ValidationErrors,
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
} from '@angular/forms';

const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9\-]+\.[a-zA-Z]+/;

@Component({
  selector: 'miq-copy-user',
  templateUrl: './copy-user.component.html',
  styleUrls: ['./copy-user.component.scss'],
  standalone: false,
})
export class CopyUserComponent implements OnInit, OnDestroy {
  public userFormGroup: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<CopyUserComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: UntypedFormBuilder
  ) {
    this.userFormGroup = this.formBuilder.group({
      email: new UntypedFormControl('', {
        validators: [Validators.required, Validators.pattern(EMAIL_REGEX)],
      }),
      rolePermissions: new UntypedFormControl(),
      profileSettings: new UntypedFormControl(),
    });
    this.userFormGroup.setValidators(this.checkPermissions());
  }

  ngOnInit() {
    /* required for static lable translation */
  }

  checkPermissions(): ValidatorFn {
    return (group: UntypedFormGroup): ValidationErrors => {
      return group.controls.rolePermissions.value || group.controls.profileSettings.value
        ? null
        : { notEquivalent: true };
    };
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  copyUser() {
    this.dialogRef.close(this.userFormGroup.value);
  }

  ngOnDestroy() {
    /** label translation purpose added */
  }
}
